import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useMemberEdit } from './hooks/useMemberEdit';
import { MemberEditFormBlock } from './components/MemberEditFormBlock';
import type { MemberEditData } from './types/memberEdit.types';

export function MemberEditPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  
  const { member, roles, teams, isLoading, isSubmitting, updateMember } = useMemberEdit(id);
  
  const [formData, setFormData] = useState<MemberEditData>({
    id: '',
    fullName: '',
    email: '',
    phone: '',
    roleCodes: [],
    status: 'active',
    teamId: ''
  });

  useEffect(() => {
    if (member) {
      setFormData(member);
    }
  }, [member]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const success = await updateMember(formData);
    if (success) {
      navigate('?tab=members');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => navigate('?tab=members')}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-slate-100 bg-white text-slate-600 active:scale-95 transition-all"
          >
            <i className="ri-arrow-left-line" />
          </button>
          <div>
            <h1 className="text-lg text-slate-900">Chỉnh sửa thành viên</h1>
            <p className="text-xs text-slate-500">Cập nhật thông tin và phân quyền tài khoản</p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="grid grid-cols-1 gap-4">
        <MemberEditFormBlock
          formData={formData}
          setFormData={setFormData}
          roles={roles}
          teams={teams}
          isLoading={isLoading}
        />

        {/* Action Buttons */}
        <div className="flex items-center justify-end gap-3 pt-4 border-t border-slate-100">
          <button
            type="button"
            onClick={() => navigate('?tab=members')}
            className="h-10 px-6 rounded-md border border-slate-200 bg-white text-sm text-slate-600 hover:bg-slate-50 active:scale-95 transition-all"
          >
            Hủy bỏ
          </button>
          <button
            type="submit"
            disabled={isSubmitting || isLoading}
            className="h-10 px-8 rounded-md bg-emerald-700 text-sm text-white hover:bg-emerald-800 disabled:opacity-50 active:scale-95 transition-all shadow-md shadow-emerald-700/10"
          >
            {isSubmitting ? 'Đang lưu...' : 'Lưu thay đổi'}
          </button>
        </div>
      </div>
    </form>
  );
}
